export default __webpack_public_path__ + "static/media/master.e447f0c9.png";